import classNames from 'classnames'
import React from 'react'
import { CGE } from '..'
import { getPageLayoutType } from '../../../utils/utilsFunc'

function DetailClient({ props, propsDetail, className, propsLabelInfoContent,helpText = true, inputText = false }) {             
  return (
    <div id="cge-detail-client" className={classNames(
      {
        "detail-client-horizontal": props.horizontal,
      }
    )}>
      <div className={classNames(
        "cge-detail-client mb-4",
      {
        "cge-detail-client-vertical": props.vertical,
      }
    )}>
        <div className={getPageLayoutType() && props.readOnly ? "col-md-6 px-0 " + className : "col-md-7 px-0 " + className}>
          {getPageLayoutType() && !inputText ? (
            <div className="d-flex">
              <div className={classNames(
                props.readOnly ? "col-md-12 pl-0 pr-0" : "col-md-8 pl-0 pr-0",
                {
                  "col-md-12": props.horizontal,
                  "d-flex": propsLabelInfoContent,
                }
              )}>
                <CGE.FormsField
                  handleChange={props.handleChangePriv}
                  hasError={props.hasError}
                  msgError={props.msgError}
                  idFormElement={props.idFormElement}
                  labelName={props.labelName}
                  typeElement={props.typeElement}
                  typeFormElement={props.typeFormElement}
                  mandatoryElement={props.mandatoryElement}
                  propsLabelInfoContent={props.propsLabelInfoContent}
                  readOnly={props.readOnly}
                  value={props.valuePriv}
                  listOptions={props.listOptions}
                  formatChars={props.formatChars}
                  mask={props.mask}
                  beforeMaskedValueChange={props.beforeMaskedValueChange}
                  maskChar={props.maskChar}
                  maxLength={props.maxLength}
                  disabled={props.disabled}
                />
              </div>
              {props.labelButton && !props.readOnly && <div className="col-md-2">
                <CGE.Spacing type="gn" />
                <CGE.Button
                  label={props.labelButton}
                  onClick={props.handleClick}
                  size={props.sizeButton}
                  type={props.typeButton}
                  typeButton={props.versionButton}
                />
              </div>}
            </div>
          ) : (
            <div className="d-flex">
              <div className={classNames(
                "col-md-8 pl-0 pr-0",
                {
                  "col-md-12": props.horizontal,
                  "d-flex": propsLabelInfoContent,
                }
              )}>
                <CGE.FormsField
                  handleChange={props.handleChange}
                  hasError={props.hasError}
                  horizontal={props.horizontal}
                  msgError={props.msgError}
                  idFormElement={props.idFormElement}
                  labelName={props.labelName}
                  mandatoryElement={props.mandatoryElement}
                  onInput={props.onInput}
                  propsLabelInfoContent={props.propsLabelInfoContent}
                  value={props.valuePub}
                  placeholder={props.placeholder}
                  readOnly={props.readOnly}
                  typeFormElement="text"
                  typeElement="input-mask"
                  maxLength="12"
                  formatChars={{
                      9: "[0-9]"
                  }}
                  mask="999999999999"
                  disabled={props.disabled}
                />
              </div>
              {props.labelButton && <div className="col-md-2">
                <CGE.Spacing type="gn" />
                <CGE.Button
                  label={props.labelButton}
                  onClick={props.handleClick}
                  size={props.sizeButton}
                  type={props.typeButton}
                  typeButton={props.versionButton}
                  disabled={props.disabledButton}
                />
              </div>}
            </div>
          )}
          <div class="row pt-0 pb-0">
            <div class="col-md-12">
              {helpText && 
                <CGE.Text
                  size="2"
                  text=""
                />
              }
            </div>
          </div>
        </div>
        {
          (props.idClient && props.idClient !== "0" && propsDetail?.ctaCtoClient === props.idClient) &&
          <div className={classNames(
            "cge-detail-client__card my-2",
            {
              "mr-3": getPageLayoutType(),
              "col-md-5 detail-client-mt": props.horizontal,
            }
          )}>
            <div className="cge-detail-client__card--icon">
              <svg width="60px" height="60px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg">
                <title>ic_fluent_contact_card_24_filled</title>
                <desc>Created with Sketch.</desc>
                <g id="🔍-Product-Icons" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                  <g id="ic_fluent_contact_card_24_filled" fill="#00A7E1" fill-rule="nonzero">
                    <path d="M19.75,4 C20.9926407,4 22,5.00735931 22,6.25 L22,17.754591 C22,18.9972317 20.9926407,20.004591 19.75,20.004591 L4.25,20.004591 C3.00735931,20.004591 2,18.9972317 2,17.754591 L2,6.25 C2,5.00735931 3.00735931,4 4.25,4 L19.75,4 Z M9.75,12.5 L6.25,12.5 C5.87030423,12.5 5.55650904,12.7821539 5.50684662,13.1482294 L5.5,13.25 L5.5,13.7417575 L5.50787101,13.8501298 C5.67047899,14.9636623 6.60213369,15.5009403 7.99995063,15.5009403 C9.33111595,15.5009403 10.2395313,15.0141183 10.4636506,14.0063541 L10.4921036,13.8512782 L10.5,13.7427321 L10.5,13.25 C10.5,12.8703042 10.2178461,12.556509 9.85177056,12.5068466 L9.75,12.5 Z M17.75,12.9961404 L13.2522936,12.9961404 L13.150523,13.002987 C12.7844475,13.0526495 12.5022936,13.3664447 12.5022936,13.7461404 C12.5022936,14.1258362 12.7844475,14.4396314 13.150523,14.4892938 L13.2522936,14.4961404 L17.75,14.4961404 L17.8517706,14.4892938 C18.2178461,14.4396314 18.5,14.1258362 18.5,13.7461404 C18.5,13.3664447 18.2178461,13.0526495 17.8517706,13.002987 L17.75,12.9961404 Z M8,8.50218109 C7.17158707,8.50218109 6.5000257,9.17374246 6.5000257,10.0021554 C6.5000257,10.8305683 7.17158707,11.5021297 8,11.5021297 C8.82841293,11.5021297 9.4999743,10.8305683 9.4999743,10.0021554 C9.4999743,9.17374246 8.82841293,8.50218109 8,8.50218109 Z M17.75,9.5 L13.2522936,9.5 L13.150523,9.50684662 C12.7844475,9.55650904 12.5022936,9.87030423 12.5022936,10.25 C12.5022936,10.6296958 12.7844475,10.943491 13.150523,10.9931534 L13.2522936,11 L17.75,11 L17.8517706,10.9931534 C18.2178461,10.943491 18.5,10.6296958 18.5,10.25 C18.5,9.87030423 18.2178461,9.55650904 17.8517706,9.50684662 L17.75,9.5 Z" id="🎨-Color"></path>
                  </g>
                </g>
              </svg>
            </div>
            <div className="cge-detail-client__card--info">
              <CGE.Heading
                className="color-blue"
                text="Datos del cliente"
                size="4"
              />
              {propsDetail["fullNameClient"] && getPageLayoutType() && <div className="cge-detail-client__card--name d-flex align-items-center">
                <div className="">
                  <CGE.Text
                    text="Nombre"
                    size="4"
                  />
                  <CGE.Text
                    text={propsDetail["fullNameClient"].replaceAll("null","")}
                    size="2"
                  />
                </div>
              </div>}
              {propsDetail["comunaClient"] &&
                <div className="cge-detail-client__card--name">
                  <CGE.Text
                    text="Dirección"
                    size="4"
                  />
                  <div className="">
                    <CGE.Text
                      text={`Comuna: ${propsDetail["comunaClient"].replaceAll("null","")}`}
                      size="2"
                    />
                    {propsDetail["calleClient"] && <CGE.Text
                      text={`Calle: ${propsDetail["calleClient"].replaceAll("null","")}`}
                      size="2"
                    />}

                    {propsDetail["nCalleClient"] && <CGE.Text
                      text={`N°: ${propsDetail["nCalleClient"].replaceAll("null","")}`}
                      size="2"
                    />}

                    {propsDetail["dptoBlockClient"] && <CGE.Text
                      text={`Block/Dpto: ${propsDetail["dptoBlockClient"].replaceAll("null","")}`}
                      size="2"
                    />
                    }
                  </div>
                </div>}
            </div>
          </div>
        }
      </div >
    </div>

  )
}

export default DetailClient